import styled from 'styled-components';

import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const IndentContainerWithBackground = styled(IndentContainer)`
    width: 100%;
    background-color: ${COLORS.BgSurface};
`;

export default IndentContainerWithBackground;
